// import React from "react";
// import Hero from "../components/Home/Hero";
// import woman from "../assets/images/businesswoman.png";

// import Article from "../components/Home/Article";
// import OfferCarrds from "../components/Home/OfferCarrds";
// import Community from "../components/Home/Community";
// import Questions from "../components/Home/Questions";
// import Footer from "../components/Home/Footer";
// const Home = () => {
//   return (
//     <div className="home">
//       <Hero />

//       <div className="section_2">
//         <Article />

//         <div className="offerText">What we Offer!</div>

//         <div className="cards">
//           <div className="offercard_container">
//             <OfferCarrds />
//           </div>
//         </div>
//       </div>

//       <Community />
//       <Questions />
//       <Footer />
//     </div>
//   );
// };

// export default Home;

import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Vision from "../components/Home/Vision";
import Hero from "../components/Home/Hero";
import Navbar from "../components/Home/Navbar";
import HowWeDifferent from "../components/Home/HowWeDifferent";
import Footer from "../components/Home/Footer";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h1: {
      fontSize: "2rem",
      "@media (min-width:600px)": {
        fontSize: "2.5rem",
      },
      "@media (min-width:900px)": {
        fontSize: "3rem",
      },
    },
    body1: {
      fontSize: "0.875rem",
      "@media (min-width:600px)": {
        fontSize: "1rem",
      },
    },
  },
  spacing: 8,
});

function Home() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <main>
        <Hero />
        <Vision />
        <HowWeDifferent />
      </main>
      <Footer />
    </ThemeProvider>
  );
}

export default Home;
